import React from 'react';
import FactoringApprovalModule from './components/ApprovalModule';
import EnhancedTab from '../../../../../../../../../../../lib/designSystem/TabSimulation';
import Evaluations from './components/Evaluations';

const FactoringRiskTab = (props: any) => {
  const {
    setOpenShoppingCart,
    selectedRequest,
    setSuccessOpen,
    setFailureOpen,
    setUp,
    selectedId,
  } = props;
  const startValue = 0;

  const tabs = [
    {
      index: 1,
      label: 'Comité',
      component: (
        <div>
          <FactoringApprovalModule
            selectedRequest={selectedRequest}
            requestType="factoring-request"
            setOpenShoppingCart={setOpenShoppingCart}
            setSuccessOpen={setSuccessOpen}
            setFailureOpen={setFailureOpen}
            setUp={setUp}
            selectedId={selectedId}
          />
        </div>
      ),
    },
    {
      index: 3,
      label: 'Evaluaciones',
      component: (
        <Evaluations
          selectedRequest={selectedRequest}
          setOpenShoppingCart={setOpenShoppingCart}
        />
      ),
    },
  ];

  return <EnhancedTab startValue={startValue} tabs={tabs} />;
};

export default FactoringRiskTab;
